<template>
  <b-container v-if="this.type" fluid>
    <h1>
      {{title || $appConfig.models[this.type].title}}
      <b-button v-if="$appConfig.models[this.type].allowNew" variant="secondary" size="sm" :to="'/new/' + type" v-translate>+ NEW</b-button>
    </h1>
    <b-card no-body class="filters">
      <b-tabs card v-model="tabIndex">
        <b-tab :title="$gettext('Quick Filters')" active>
          <b-card-text>
            <form @submit.prevent="updateQuickFilters">
              <b-row>
                <b-col class="text-center filter-actions">
                  <b-button size="sm" variant="success" type="submit" v-translate>
                    Apply Filters
                  </b-button>
                  <b-badge size="md" @click="resetQuickFilters" v-translate>Reset Filters</b-badge> <b-badge size="sm" @click="saveCurrentQuickFilters" v-translate>Save this Filters' Set</b-badge>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3" md="2">
                  <b-form-group>
                    <label for="filter-statuses" v-translate>Statuses</label>
                    <b-form-checkbox-group stacked id="filter-statuses" v-model="filter.statuses" :options="statuses"></b-form-checkbox-group>
                  </b-form-group>
                  <b-form-group>
                    <label for="filter-street" v-translate>Include Street Tours?</label>
                    <b-form-radio-group stacked id="filter-scheduleds" v-model="filter.street">
                      <b-form-radio value="null"><translate>All</translate></b-form-radio>
                      <b-form-radio value="1"><translate>Street Only</translate></b-form-radio>
                      <b-form-radio value="0"><translate>Without Street</translate></b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="5">
                  <div class="form-group">
                    <label for="search-courier" v-translate>Tour ID</label>
                    <input id="inline-form-input-name" v-model.lazy="filter.tourId" type="text" class="mb-2 col-12 form-control">
                  </div>
                  <div class="form-group">
                    <label for="search-label" v-translate>Tour Label</label>
                    <input id="search-label" v-model.lazy="filter.label" type="text" class="mb-2 col-12 form-control">
                  </div>

                  <div class="form-group">
                    <label for="search-fuzzy-origin" v-translate>Fuzzy Origin Search</label>
                    <input id="search-fuzzy-origin" v-model.lazy="filter.origin" type="text" class="mb-2 col-12 form-control">
                  </div>

                  <div class="form-group">
                    <b-form-checkbox v-model="filter.withoutCourier" :value="null" :disabled="filter.statuses.length > 0 && filter.statuses.indexOf('READY') === -1">
                      <translate>Without courier assigned</translate>
                    </b-form-checkbox>
                  </div>
                </b-col>
                <b-col>
                  <div class="form-group"><br>
                    <user-autocomplete ref="courierAc" :placeholder="$gettext('Courier Name or Email')" :restrictToRoles="['courier']" @selected="onSearchCourierSelected" with-picture />
                    <b-badge v-for="(item, index) in filter.courier" :key="index">
                      {{ item.email }} <b-badge variant="danger" href="#" @click.prevent="removeCourierFromFilters(index)">×</b-badge>
                    </b-badge>
                  </div>
                  <div class="form-group">
                    <b-row>
                      <b-col cols="6">
                        <label class="" for="inline-form-input-name" v-translate>Created At Date Range </label><label v-show="filter.createdDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetCreatedDateRange" v-translate>reset range</a>]</label>
                        <date-range-picker
                          v-if="datepickerLocalized"
                          v-model="createdDateRange"
                          @update="filter.createdDateRangeActive++"
                          :locale-data="locale1"
                          :opens="opens1"
                          class="w-100"
                          :ranges="ranges"
                        >
                          <div slot="input" slot-scope="picker">
                            <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                            <span v-if="filter.createdDateRangeActive === 0" style="vertical-align: middle">...</span>
                            <span v-else style="vertical-align: middle">{{moment(createdDateRange.startDate).format('L')}} - {{moment(createdDateRange.endDate).format('L')}}</span>
                          </div>
                        </date-range-picker>
                      </b-col>
                      <b-col>
                        <label class="" for="inline-form-input-name" v-translate>Updated At Date Range </label><label v-show="filter.updatedDateRangeActive !== 0">&nbsp;[<a href="#" @click.prevent="resetUpdatedDateRange" v-translate>reset range</a>]</label>
                        <date-range-picker
                          v-if="datepickerLocalized"
                          v-model="updatedDateRange"
                          @update="filter.updatedDateRangeActive++"
                          :locale-data="locale2"
                          :opens="opens2"
                          class="w-100"
                          :ranges="ranges"
                        >
                          <div slot="input" slot-scope="picker">
                            <font-awesome-icon :icon="['far', 'calendar-alt']" size="1x" style="vertical-align: middle" />
                            <span v-if="filter.updatedDateRangeActive === 0" style="vertical-align: middle">...</span>
                            <span v-else style="vertical-align: middle">{{moment(updatedDateRange.startDate).format('L')}} - {{moment(updatedDateRange.endDate).format('L')}}</span>
                          </div>
                        </date-range-picker>
                        </b-col>
                    </b-row>
                  </div>
                  <div class="form-group">
                    <b-form-checkbox v-model="filter.fixedPriceOnly" :value="true"><translate>Fixed Price Only</translate></b-form-checkbox>
                  </div>
                </b-col>
              </b-row>
            </form>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Advanced Filters')">
          <b-card-text>
            <b-row>
              <b-col lg="12" class="my-1">
                <listing-filter :type="type" @save-filter="saveCurrentAdvancedFilters" :filter-fields="filterFields" :pre-filters="preFilters" @refresh="refreshTable" ref="listingFilters" />
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab :title="$gettext('Saved Filters')" :disabled="savedToursQuickSearches.length === 0">
          <b-list-group>
            <b-list-group-item v-for="(savedQuickSearch, index) in savedToursQuickSearches" :key="index" :href="savedQuickSearch.url" class="d-flex justify-content-between align-items-center">
              {{ savedQuickSearch.name }}
              <b-badge href="#" @click.stop.prevent="deleteSavedQuickSearch(index)" variant="danger">✕</b-badge>
            </b-list-group-item>
          </b-list-group>
        </b-tab>
      </b-tabs>
    </b-card>

    <b-row class="mb-3">
      <b-col>
        <b-form-checkbox inline v-model="selectAllTrigger"><translate>Select/Unselect All</translate></b-form-checkbox>
        <b-button size="sm" @click.stop="openTourMap()" style="padding:.5rem 1rem" title="Quick view Tour Map" :disabled="selected.length === 0">
          <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 18px;vertical-align: middle" />
          <translate>View on Map</translate>
        </b-button>

        <b-button size="sm" variant="primary" @click.stop="downloadCsv()" style="padding:.5rem 1rem" title="Export CSV from selected" :disabled="selected.length === 0" v-translate>
          Export CSV from selected
        </b-button>
        <b-button size="sm" variant="primary" @click.stop="downloadCsv(true)" style="padding:.5rem 1rem" title="Export CSV (Admin View) from selected" :disabled="selected.length === 0" v-if="isOperatorSupervisor || isAccountant || isSuperAdmin" v-translate>
          Export Admin View CSV (Internal Report, don't share with Clients)
        </b-button>
        <b-button size="sm" variant="secondary" @click.stop="mergeTours(); merging = true" style="padding:.5rem 1rem" title="Merge Selected Tours" :disabled="!isMergeable || merging">
          <b-spinner small v-if="merging"></b-spinner>
          <translate>Merge Selected Tours</translate>
        </b-button>
      </b-col>
      <b-col cols="12" sm="3" lg="2">
        <b-form-group horizontal :label="$gettext('Per page')" :label-cols="6" class="text-right mb-0">
          <b-form-select  cols="6" :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="bg-white py-1" v-translate="{totalRows: totalRows || '-'}">
        Total items: <strong>%{totalRows}</strong>
      </b-col>
    </b-row>
    <b-table @row-selected="rowSelected" ref="toursTable" stacked="md" foot-clone :total-rows="totalRows" :sort-desc="sortDesc" :sort-by="sortBy" :per-page="perPage" :current-page="currentPage" :items="myProvider" :fields="fields" :api-url="this.$appConfig.api.baseUrl + this.$appConfig.models[this.type].endpoint" select-mode="multi" selectedVariant="secondary" id="my-table" selectable>

      <div slot="table-busy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong v-translate>Loading...</strong>
      </div>
      <template v-slot:cell(id)="data">
        <a :href="'/edit/' + type + '/' + data.value">{{data.value | uuid }}</a> <a href="#" @click.prevent="copyToClipboard(data.value)" class="text-secondary" :title="$gettext('Copy to Clipboard')"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
        <div v-if="data.item.has_relevant_centroid === false">
          <b-badge variant="info" v-translate>Street</b-badge>
        </div>
      </template>

      <template v-slot:cell(label)="row">
        {{row.value}}<br>
        <div v-for="(item, index) in row.item.sizes" :key="index">
          <b-badge class="mr-1" variant="dark">{{index}}</b-badge>
          <span
            v-translate="{count: item}"
            :translate-n="item"
            translate-plural="%{ count } shippings"
          >%{ count } shipping
          </span>
        </div>
        <div class="first-visit" v-if="row.item.visits[0]">
          <font-awesome-icon icon="crosshairs" /> {{row.item.visits[0].address_name.split(',').slice(1).join(',')}}
        </div>
      </template>

      <template v-slot:cell(stops)="row">
        <div class="text-nowrap">
          <a href="#" v-b-modal.modalVisitsOverview @click.stop.prevent="currentVisits4Show = row.item.visits4Show">{{row.item.visits4Show.length}}</a> ({{row.item.pickups}}&#8593; - {{row.item.dropoffs}}&#8595;)
        </div>
        <div class="text-nowrap">
          {{row.item.total_distance || '-'}} km.
        </div>
        <div class="text-nowrap" v-translate="{etc: moment().startOf('day').add(row.item.estimated_completion_time, 'minutes').format(row.item.estimated_completion_time < 60 ? 'm' : 'hh:mm') + (row.item.estimated_completion_time < 60 ? ' min' : ' hs')}">
          ETC: %{etc}
        </div>

      </template>

      <template v-slot:cell(comment)="row">
        <span v-html="$options.filters.brize(row.value)"></span>
      </template>

      <template v-slot:cell(optimized)="row">
        <span :title="!row.item.notOptimized && row.item.visits.findIndex(x => x.order === null) === -1 ? 'Optimized Tour :)' : 'This tour has been modified and it IS NOT optimized'" style="display: inline-block; width:15px; height:15px; border-radius: 100px;" :class="row.item.status === 'DRAFT' ? 'bg-danger' : (!row.item.notOptimized && row.item.visits.findIndex(x => x.order === null) === -1  ? 'bg-success' : 'bg-warning')"></span>
      </template>

      <template v-slot:cell(status)="row">
        <div v-if="row.item.warehouse_slot">
          <b-badge variant="dark" v-if="row.item.warehouse_slot">{{row.item.warehouse_slot.reference}} ({{row.item.warehouse_slot.content.length}}/{{Object.values(row.item.sizes).reduce((a, b) => a + b)}})</b-badge>
        </div>
        {{row.item.status}}
        <small v-if="row.item.waiting" v-translate>(WAITING)</small>
        <small v-if="row.item.reprocess" class="bg-warning" v-translate>REROUTING</small>
        <span v-if="row.item.fixed_amount_price_schedules[0] && row.item.fixed_amount_price_schedules[0].status !== 'canceled'">
          <br>
          <b-badge
            :variant="getTake(row.item.price, row.item.commission) >= 30 ? 'success' : (getTake(row.item.price, row.item.commission) < 30 && getTake(row.item.price, row.item.commission) > 0 ? 'warning' : 'danger')"
            :id="'fixed-price-' + row.item.fixed_amount_price_schedules[0].id"
            v-translate
          >
            FIXED PRICE
          </b-badge>
          <b-tooltip :target="'fixed-price-' + row.item.fixed_amount_price_schedules[0].id">
            <div class="m-2">
              <span v-translate="{data: moment.utc(row.item.fixed_amount_price_schedules[0].from_date).tz($tz).format('L LT')}">Starting at: %{data}</span><br>
              <span v-translate="{data: moment.utc(row.item.fixed_amount_price_schedules[0].to_date).tz($tz).format('L LT')}">Ending at: %{data}</span><br>
              <span v-translate="{data: row.item.fixed_amount_price_schedules[0].amount + ' ' + row.item.fixed_amount_price_schedules[0].currency}">Amount: %{data}</span><br>
              <span v-translate="{maxExtraHours: row.item.fixed_amount_price_schedules[0].fixed_tour.max_extra_hours, price: row.item.fixed_amount_price_schedules[0].fixed_tour.extra_hour_price}"><abbr title="Maximum Extra Hours">M.E.H.</abbr>: %{maxExtraHours} <small>(%{price}/Hour)</small></span>
              <hr class="bg-light my-1">
              <span v-html="sanityDetail(row.item)"></span>
            </div>
          </b-tooltip>
        </span>
        <span v-else>
          <br>
          <b-badge
            :variant="getTake(row.item.price, row.item.commission) >= 30 ? 'success' : (getTake(row.item.price, row.item.commission) < 30 && getTake(row.item.price, row.item.commission) > 0 ? 'warning' : 'danger')"
            :id="'sanity-' + row.item.id"
          >
            <span v-if="getTake(row.item.price, row.item.commission) >= 30" v-translate>SANE</span>
            <span v-else-if="getTake(row.item.price, row.item.commission) < 0" v-translate>NOT SANE</span>
            <span v-else v-translate>SEMI SANE</span>
          </b-badge>
          <b-tooltip :target="'sanity-' + row.item.id">
            <div class="m-2" v-html="sanityDetail(row.item)"></div>
          </b-tooltip>
        </span>
        <div v-html="priceByKm(row.item)"></div>
      </template>

      <template v-slot:cell(scheduled_date)="row">
        <div v-if="row.item.scheduled_date">
          {{moment.utc(row.item.scheduled_date).tz($tz).format('YYYY-MM-DD')}}<br>
          {{moment.utc(row.item.scheduled_date).tz($tz).format('HH:mm:ss')}}
        </div>
      </template>

      <template v-slot:cell(updated_at)="row">
        {{moment.utc(row.item.updated_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.updated_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(created_at)="row">
        {{moment.utc(row.item.created_at).tz($tz).format('YYYY-MM-DD')}}<br>
        {{moment.utc(row.item.created_at).tz($tz).format('HH:mm:ss')}}
      </template>

      <template v-slot:cell(courier_id)="row">
        <div v-if="row.item.courier">
          <user-card :user='row.item.courier' :profile-picture="false" :with-titles="false" :vehicle-types-prop="vehicleTypes" />
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <b-button pill size="sm" @click.stop="row.toggleDetails" style="padding: .5rem">
          <font-awesome-icon v-if="row.detailsShowing" :icon="['far', 'eye-slash']" size="2x" style="font-size: 16px;vertical-align: middle" />
          <font-awesome-icon v-else :icon="['far', 'eye']" size="2x" style="font-size: 16px;vertical-align: middle" />
        </b-button>
        <b-button pill size="sm" @click.stop="openTourMap(row.index)" style="padding:.5rem" :title="$gettext('Quick view Tour Map')">
          <font-awesome-icon :icon="['fa', 'map-marked-alt']" size="2x" style="font-size: 18px;vertical-align: middle" />
        </b-button>
        <b-button pill size="sm" variant="dark" v-if="row.item.status === 'READY' && row.item.courier_id === null && !row.item.waiting" @click.stop="takeCheck('waiting', row.item)" style="font-size: 1.2rem; line-height: 1; padding:.5rem .55rem" :title="$gettext('Set tour as WAITING')">
          W
        </b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key" v-if="value && value.length !== 0 && value !== 'undefined' && value !== null">{{ key }}: <span v-html="key.indexOf('phone') === -1 ? isJson(value) : value.toString()"></span></li>
          </ul>
        </b-card>
      </template>
    </b-table>
    <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />

    <b-modal id="modalTourMap" size="xl" ref="modalTourMap" @shown="addMarkers" @hide="$refs.fullMap.markers = []; $refs.fullMap.polyLines = []" :hide-header="true" :hide-footer="true">
      <div slot="modal-title" v-translate>Collection Map</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <leaflet-map ref="fullMap" style="height:80vh" :fitAlways="true" :geolocate="false" />
    </b-modal>

    <b-modal id="modalVisitsOverview" size="lg" ref="modalVisitsOverview" @hide="currentVisits4Show = []">
      <div slot="modal-title" v-translate>Visits Overview</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <bRow>
        <bCard v-for="(visit, index) in currentVisits4Show" :key="index" :class="visit.visited === 1 ? 'bg-success text-light' : ''">
          <bRow>
            <bCol cols="1">
              <h1>{{index+1}}</h1>
            </bCol>
            <bCol cols="11">
              <p v-translate="{data: visit.shipping_ids.join(', ')}">ID/s: <strong>%{data}</strong></p>
              <p>
                <span v-translate="{data: visit.type + (visit.shipping_ids.length > 1 ? ' multiple' : '')}">Type: <strong>%{data}</strong></span><br>
                <span v-translate="{data: visit.address_name}">Address: <strong>%{data}</strong></span><br>
                <span v-translate="{data: visit.address_extra}">Address Extra: <strong>%{data}</strong></span>
                <br>
                <span v-translate="{data: visit.visited === 1 ? $gettext('YES') : $gettext('NO')}">Visited: <strong>%{data}</strong></span>
              </p>
            </bCol>
          </bRow>
        </bCard>
      </bRow>
    </b-modal>

    <div class="modal-backdrop d-flex text-center" v-if="updating">
      <div class="align-self-center" style="flex-grow: 1">
        <b-spinner variant="white" />
      </div>
    </div>
  </b-container>
</template>

<script>
function initialQuickFilters() {
  return {
    statuses: [],
    street: '0',
    tourId: '',
    label: '',
    origin: '',
    courier: [],
    withoutCourier: false,
    createdDateRangeActive: 0,
    updatedDateRangeActive: 1,
    fixedPriceOnly: false
  }
}
import ToursMixin from '@/mixins/tours.mixin'
import ListingFilter from '@/components/ListingFilter'
import DateRangePicker from 'vue2-daterange-picker'
import UserCard from '@/components/UserCard'
import LeafletMap from '@/components/LeafletMap'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'

export default {
  name: 'ApiList',
  components: {
    ListingFilter,
    DateRangePicker,
    UserCard,
    LeafletMap,
    UserAutocomplete
  },
  props: {
    type: {
      type: String,
      default: 'tours'
    },
    title: {
      type: String
    },
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    prePerPage: {
      type: Number,
      default: 25
    }
  },
  data () {
    return {
      items: [],
      fields: [],
      filterFields: this.$appConfig.models[this.type].filters,
      exclude: this.$appConfig.models[this.type].exclude,
      includes: this.$appConfig.models[this.type].includes || [],
      isBusy: false,
      currentPage: 1,
      perPage: this.prePerPage,
      totalRows: null,
      pageOptions: [ 10, 25, 50, 100 ],
      sortBy: 'updated_at',
      sortDesc: true,
      sortDirection: 'desc',
      filters: this.preFilters,
      addressAcInput: '',
      start_location: {},
      markers: [],
      polyLines: [],
      selectAllTrigger: false,
      selected: [],
      lastId: 1,
      mapDataIndex: 0,
      routeColors: [
        'FF6C87',
        '8A89E1',
        'C5E662',
        '4DA2FF',
        'FFB54D',
        'F03A47',
        '1B998B',
        '6d05d6',
        '000000',
        'C5D86D',
        '712F79',
        'F7996E',
        '48639C',
        'CA895F',
        '4E3822',
        '06BEE1',
        'ff6600',
        '319200',
        '653300',
        '884cff',
        '2B193D'
      ],
      currentVisits4Show: [],
      tabIndex: 0,
      savedToursQuickSearches: [],
      advancedFilters: [],
      filter: initialQuickFilters(),
      quickFilters: {},
      statuses: [
        'DRAFT',
        'READY',
        'WAITING',
        'INTRANSIT',
        'FINISHED',
        'CANCELED'
      ],
      searchQuery: '',
      searchCourierQuery: '',
      selectedSearchItem: null,
      acOptions: {
        debounce: 500,
        placeholder: this.$gettext('Courier Name or Email'),
        inputClass: 'form-control'
      },
      minCharacter: 2,
      createdDateRange: { // used for v-model prop
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      },
      updatedDateRange: { // used for v-model prop
        startDate: this.moment().subtract(2, 'days').toDate(),
        endDate: this.moment().toDate()
      },
      opens1: 'left', //  which way the picker opens, default "center", can be "left"/"right"
      opens2: 'left',
      locale1: {},
      locale2: {},
      ranges: { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('This year')]: [this.moment().startOf('year').toDate(), this.moment().endOf('year').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      },
      datepickerLocalized: false,
      merging: false
    }
  },
  watch: {
    type: function (val) {
      console.log(this.type)
      console.log(val)
      this.resetData()
      this.$refs.listingFilters.resetData()
      this.fields = this.$appConfig.models[this.type].fields
      this.filterFields = this.$appConfig.models[this.type].filters
      this.exclude = this.$appConfig.models[this.type].exclude
      this.fields.push({ key: 'actions', label: this.$gettext('Actions') })
      let that = this
      this.fields = this.fields.filter(function (obj) {
        if (that.exclude) {
          return that.exclude.indexOf(obj.key) === -1
        } else {
          return true
        }
      })
      this.refreshTable()
    },
    exclude: function (val) {
      return this.$appConfig.models[this.type].exclude
    },
    selectAllTrigger: function (val) {
      if (val === true) {
        this.selectAll()
      } else {
        this.unselectAll()
      }
    },
    'filter.statuses': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['statuses'] = [ 'status', 'in', val ]
        } else {
          this.quickFilters['statuses'] = []
        }
      },
      deep: true
    },
    'filter.street': {
      handler (val) {
        if (val === '1') {
          this.quickFilters['hasRelevantCentroid'] = [ 'has_relevant_centroid', 'eq', 0 ]
        } else if (val === '0') {
          this.quickFilters['hasRelevantCentroid'] = [ 'has_relevant_centroid', 'eq', 1 ]
        } else {
          this.quickFilters['hasRelevantCentroid'] = []
        }
      },
      deep: true
    },
    'filter.tourId': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['tourId'] = [ 'id', 'ct', val ]
        } else {
          this.quickFilters['tourId'] = []
        }
      },
      deep: true
    },
    'filter.label': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['label'] = [ 'label', 'ct', val ]
        } else {
          this.quickFilters['label'] = []
        }
      },
      deep: true
    },
    'filter.origin': {
      handler (val) {
        if (val.length > 0) {
          this.quickFilters['origin'] = [ 'visits.address_name', 'ct', val ]
        } else {
          this.quickFilters['origin'] = []
        }
      },
      deep: true
    },
    'filter.courier': {
      handler (val) {
        if (val.length > 0) {
          let couriers = val.map(function (item) {
            return item.id
          })
          let courierEmails = val.map(function (item) {
            return item.email
          })
          this.quickFilters['courier'] = [[ 'courier_id', 'in', couriers ], courierEmails]
        } else {
          this.quickFilters['courier'] = []
        }
      },
      deep: true
    },
    'filter.withoutCourier': {
      handler (val) {
        if (val === null) {
          this.quickFilters['withoutCourier'] = [ 'courier_id', 'eq', val ]
        } else {
          this.quickFilters['withoutCourier'] = []
        }
      },
      deep: true
    },
    'filter.createdDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['createdAtFrom'] = ['created_at', 'gte', this.moment(this.createdDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['createdAtTo'] = ['created_at', 'lte', this.moment(this.createdDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.filter.updatedDateRangeActive = 0
        } else {
          this.quickFilters['createdAtFrom'] = []
          this.quickFilters['createdAtTo'] = []
          this.filter.updatedDateRangeActive = 1
        }
      },
      deep: true
    },
    'filter.updatedDateRangeActive': {
      handler (val) {
        if (val !== 0) {
          this.quickFilters['updatedAtFrom'] = ['updated_at', 'gte', this.moment(this.updatedDateRange.startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.quickFilters['updatedAtTo'] = ['updated_at', 'lte', this.moment(this.updatedDateRange.endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')]
          this.filter.createdDateRangeActive = 0
        } else {
          this.quickFilters['updatedAtFrom'] = []
          this.quickFilters['updatedAtTo'] = []
        }
      },
      deep: true
    },
    'filter.fixedPriceOnly': {
      handler (val) {
        if (val === true) {
          this.quickFilters['fixedPriceOnly'] = [ 'fixed_amount_price_schedules.status', 'eq', 'canceled', 'true' ]
        } else {
          this.quickFilters['fixedPriceOnly'] = []
        }
      },
      deep: true
    },
    tabIndex(val) {
      if (val === 1) {
        this.checkAdvancedFilters()
      } else if (val === 0) {
        this.checkQuickFilters()
      }
    }
  },
  computed: {
    isMergeable() {
      return this.selected.length >= 2 && this.selected.findIndex(x => x.courier_id !== null) === -1 && this.selected.findIndex(x => x.status !== 'READY') === -1 && this.selected.findIndex(x => x.waiting === true) === -1
    },
    applyFilter () {
      return this.filter
    }
  },
  mixins: [
    ToursMixin
  ],
  created() {
    this.fetchShippingSizes()
    this.fetchVehicleTypes()
    window.addEventListener('popstate', () => {
      if (this.$route.query.s) {
        this.tabIndex = 1
        this.checkAdvancedFilters()
      } else if (this.$route.query.qs) {
        this.tabIndex = 0
        this.checkQuickFilters()
      }
    })
  },
  mounted() {
    this.resetData()
    this.fields = this.$appConfig.models[this.type].fields
    this.includes = this.$appConfig.models[this.type].includes
    this.exclude = this.$appConfig.models[this.type].exclude
    let that = this
    let fields = this.fields.filter(function (obj) {
      if (that.exclude) {
        return that.exclude.indexOf(obj.key) === -1
      } else {
        return true
      }
    })
    fields.push({ key: 'actions', label: this.$gettext('Actions') })
    this.fields = fields
    if (this.$route.query.s) {
      this.tabIndex = 1
      this.checkAdvancedFilters()
    } else if (this.$route.query.qs) {
      this.checkQuickFilters()
    } else {
      this.refreshTable()
    }
    if (localStorage.savedToursQuickSearches) {
      this.savedToursQuickSearches = JSON.parse(localStorage.savedToursQuickSearches)
    }
    this.initDatePicker()
  },
  methods: {
    initDatePicker() {
      this.locale1 = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.locale2 = {
        direction: 'ltr', //  direction of text
        format: 'dd/mm/yyyy', //  fomart of the dates displayed
        separator: ' - ', //  separator between the two ranges
        applyLabel: this.$gettext('Apply'),
        cancelLabel: this.$gettext('Cancel'),
        weekLabel: 'W',
        customRangeLabel: this.$gettext('Custom Range'),
        daysOfWeek: this.moment.weekdaysMin(), // days, //  array of days - see moment documenations for details
        monthNames: this.moment.monthsShort(), //  array of month names - see moment documenations for details
        firstDay: 1,
        showWeekNumbers: false //  show week numbers on each row of the calendar
      }
      this.ranges = { //  default value for ranges object (if you set this to false ranges will no be rendered)
        [this.$gettext('Today')]: [this.moment().toDate(), this.moment().toDate()],
        [this.$gettext('Yesterday')]: [this.moment().subtract(1, 'days').toDate(), this.moment().subtract(1, 'days').toDate()],
        [this.$gettext('Last 7 days')]: [this.moment().subtract(6, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('Last 30 days')]: [this.moment().subtract(29, 'day').startOf('day').toDate(), this.moment().subtract(0, 'day').endOf('day').toDate()],
        [this.$gettext('This month')]: [this.moment().startOf('month').toDate(), this.moment().endOf('month').toDate()],
        [this.$gettext('This year')]: [this.moment().startOf('year').toDate(), this.moment().endOf('year').toDate()],
        [this.$gettext('Last week')]: [this.moment().subtract(1, 'week').startOf('week').toDate(), this.moment().subtract(1, 'week').endOf('week').toDate()],
        [this.$gettext('Last month')]: [this.moment().subtract(1, 'month').startOf('month').toDate(), this.moment().subtract(1, 'month').endOf('month').toDate()]
      }
      this.datepickerLocalized = true
    },
    tourShippingSizes(shippings) {
      const sizes = shippings.map(x => {
        return x.size_id ? this.shippingSizes.find(y => y.id === x.size_id).name : 'no-size'
      })
      return sizes.reduce(function (counter, item) {
        let p = (String)(item)
        counter[p] = counter.hasOwnProperty(p) ? counter[p] + 1 : 1
        return counter
      }, {})
    },
    mergeTours() {
      if (
        confirm(this.$gettext('Are you sure you want to MERGE the selected tours?'))
      ) {
        let orderedSelection = this.selected.sort(function (a, b) {
          a.shippings = [...new Set(a.visits.map(x => x.shipping_id))]
          b.shippings = [...new Set(b.visits.map(x => x.shipping_id))]
          if (a.shippings.length > b.shippings.length) {
            return -1
          } else if (a.shippings.length < b.shippings.length) {
            return 1
          } else {
            return 0
          }
        })

        const baseTour = orderedSelection[0]
        orderedSelection.shift()

        for (let i = 0; i < orderedSelection.length; i++) {
          let tourShippings = orderedSelection[i].shippings

          this.$http.delete(this.$appConfig.api.baseUrl + 'tours/' + orderedSelection[i].id + '/shippings', {body: tourShippings.filter(n => n)})
            .then(response => {
              this.$http.post(this.$appConfig.api.baseUrl + 'tours/' + baseTour.id + '/shippings', tourShippings.filter(n => n))
                .then(response => {
                  if (i === orderedSelection.length - 1) {
                    this.$http.post(this.$appConfig.api.baseUrl + 'tours/' + baseTour.id + '/generate-route')
                      .then(response => {
                        this.merging = false
                        this.selected = []
                        this.updateQuickFilters()
                      })
                  }
                })
            })
        }
      }
    },
    checkAdvancedFilters() {
      // this.quickFilters = []
      if (this.$route.query.s) {
        this.advancedFilters = JSON.parse(this.$route.query.s)
        this.$refs.listingFilters.filters = this.advancedFilters
        console.log(this.advancedFilters)
      }
      this.refreshTable(this.advancedFilters)
    },
    checkQuickFilters() {
      this.advancedFilters = []
      this.$refs.listingFilters.resetData()
      if (this.$route.query.qs) {
        this.quickFilters = JSON.parse(this.$route.query.qs)
        Object.keys(JSON.parse(this.$route.query.qs)).forEach(function (key) {
          if (this.quickFilters[key].length > 2) {
            if (key === 'withoutTour') {
              if (this.quickFilters[key].length === 4) {
                this.filter[key] = 'false'
                return
              }
            }
            if (key === 'updatedAtFrom') {
              this.updatedDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'updatedAtTo') {
              this.updatedDateRange.endDate = this.quickFilters[key][2]
              this.filter.updatedDateRangeActive = true
            }
            if (key === 'createdAtFrom') {
              this.createdDateRange.startDate = this.quickFilters[key][2]
            }
            if (key === 'createdAtTo') {
              this.createdDateRange.endDate = this.quickFilters[key][2]
              this.filter.createdDateRangeActive = true
            }
            this.filter[key] = this.quickFilters[key][2]
          } else if (this.quickFilters[key].length === 2) {
            this.filter[key] = []
            for (let i = 0; i < this.quickFilters[key][0][2].length; i++) {
              this.filter[key].push({id: this.quickFilters[key][0][2][i], name: this.quickFilters[key][1][i], email: this.quickFilters[key][1][i]})
            }
          }
          if (this.quickFilters.statuses.length > 0 && this.quickFilters.statuses[2].indexOf('READY') === -1 && this.quickFilters.statuses[2].indexOf('WAITING') === -1) {
            this.filter.withoutTour = 'indeterminate'
          }
        }.bind(this))
        this.updateQuickFilters()
      }
    },
    updateQuickFilters() {
      if (this.tabIndex === 0) {
        this.currentPage = 1
        let filters = []
        Object.values(this.quickFilters).forEach(function (filter) {
          if (filter.length === 2) {
            filters.push(filter[0])
          } else {
            filters.push(filter)
          }
        })
        if (filters.length > 0) {
          this.$router.push({ query: {qs: this.localizeDates(JSON.stringify(this.quickFilters))} })
        }
        this.refreshTable(filters)
      }
    },
    resetQuickFilters: function () {
      this.resetUpdatedDateRange()
      this.resetCreatedDateRange()
      Object.assign(this.$data.filter, initialQuickFilters())
      this.$nextTick(() => {
        this.updateQuickFilters()
      })
    },
    saveCurrentQuickFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedToursQuickSearches.push({name: 'QUICK: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedToursQuickSearches = JSON.stringify(this.savedToursQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedToursQuickSearches = JSON.parse(localStorage.savedToursQuickSearches)
    },
    resetAdvancedFilters: function () {
      this.$refs.listingFilters.resetData()
      this.$refs.listingFilters.emitRefresh()
    },
    saveCurrentAdvancedFilters() {
      let name = prompt(this.$gettext('Please set a name for this Filters Set'))
      if (name) {
        this.savedToursQuickSearches.push({name: 'ADVANCED: ' + name, url: window.location.href})
      } else {
        alert(this.$gettext('You must write a name for this Filters Set'))
      }
      try {
        localStorage.savedToursQuickSearches = JSON.stringify(this.savedToursQuickSearches)
      } catch (e) {
        alert(this.$gettext('The Filters couldn\'t be saved'))
      }
      this.savedToursQuickSearches = JSON.parse(localStorage.savedToursQuickSearches)
    },
    deleteSavedQuickSearch(index) {
      this.savedToursQuickSearches.splice(index, 1)
      localStorage.savedToursQuickSearches = JSON.stringify(this.savedToursQuickSearches)
      this.savedToursQuickSearches = JSON.parse(localStorage.savedToursQuickSearches)
    },
    onSearchCourierSelected(item) {
      this.filter.courier.push({id: item.id, email: item.email})
      this.$refs.courierAc.searchQuery = ''
    },
    removeCourierFromFilters(index) {
      this.filter.courier.splice(index, 1)
    },
    resetCreatedDateRange() {
      this.createdDateRange = {
        startDate: this.moment().toDate(),
        endDate: this.moment().toDate()
      }
      this.filter.createdDateRangeActive = 0
      this.filter.updatedDateRangeActive = 1
    },
    resetUpdatedDateRange() {
      this.updatedDateRange = {
        startDate: this.moment().subtract(2, 'days').toDate(),
        endDate: this.moment().toDate()
      }
      this.filter.updatedDateRangeActive = 0 // hack to fire watcher
      this.filter.updatedDateRangeActive = 1
      this.filter.createdDateRangeActive = 0
    },
    prepareTourMapData(row, index, withCourier) {
      let lat
      let lng
      let icon = ''
      let markers = []
      let infoWindowHtml
      if (row.courier && row.courier.courier_available && row.courier.courier_available.tracking) {
        if (row.courier.courier_available.tracking[0] && withCourier) {
          icon = this.$appConfig.staticBaseUrl + 'static/img/ic-map-' + this.vehicleTypes.find(x => x.id === row.courier.courier_available.vehicle_type_id).name.toLowerCase() + '-gray.svg'

          infoWindowHtml = this.$gettextInterpolate(this.$gettext('<p>User: <strong>%{data}</strong></p>'), {data: row.courier.name})
          infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Email: <a href="mailto:%{data}"><strong>%{data}</strong></a></p>'), {data: row.courier.email})
          infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Phone: <a href="tel:%{data}"><strong>%{data}</strong></a></p>'), {data: row.courier.phone})
          markers.push({
            id: 1000,
            lat: row.courier.courier_available.tracking[0].lat,
            lng: row.courier.courier_available.tracking[0].lng,
            icon: icon,
            x: 25,
            y: 25,
            infoText: {id: row.courier.id, type: 'courier', html: infoWindowHtml, user: row.courier},
            popup: true
          })
        }
      }
      for (let i = 0; i < row.visits4Show.length; i++) {
        switch (row.visits4Show[i].visited) {
          case 0:
            icon = {
              type: 'map-marker',
              size: [27, 36],
              anchor: [13.5, 36],
              color: '#' + this.routeColors[this.mapDataIndex],
              text: (row.visits4Show[i].type === 'pickup' ? '↑' : '↓') + (i + 1)
            }
            break
          case 1:
            icon = {
              type: 'map-marker',
              size: [27, 36],
              anchor: [13.5, 36],
              color: '#28a745',
              text: (row.visits4Show[i].type === 'pickup' ? '↑' : '↓') + (i + 1)
            }
            break
        }

        if (row.visits4Show[i].lat !== null) {
          lat = row.visits4Show[i].lat
          lng = row.visits4Show[i].lng
        }

        infoWindowHtml = this.$gettextInterpolate(this.$gettext('<p>Type: <strong>%{data}</strong></p>'), {data: row.visits4Show[i].type + (row.visits4Show[i].shipping_ids.length > 1 ? ' multiple' : '')})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Address: <strong>%{data}</strong></p>'), {data: row.visits4Show[i].address_name})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Address Extra: <strong>%{data}</strong></p>'), {data: row.visits4Show[i].address_extra || ''})
        infoWindowHtml += this.$gettextInterpolate(this.$gettext('<p>Visited: <strong>%{data}</strong></p>'), {data: (row.visits4Show[i].visited === 1 ? this.$gettext('YES') : this.$gettext('NO'))})
        markers.push({
          id: this.lastId,
          lat: lat,
          lng: lng,
          icon: icon,
          x: 11,
          y: 34,
          infoText: {id: this.lastId + i + row.visits4Show[i].shipping_id, type: 'shipping', html: infoWindowHtml, ids: row.visits4Show[i].shipping_ids},
          popup: true
        })
        this.lastId++
      }

      let data = {
        line: {
          polyLine: row.visits4Show,
          polyLineOptions: {strokeColor: '#' + this.routeColors[this.mapDataIndex]}
        },
        markers: markers
      }

      if (this.mapDataIndex < this.routeColors.length - 1) {
        this.mapDataIndex++
      } else {
        this.mapDataIndex = 0
      }
      return data
    },
    openTourMap(index) {
      let data
      this.lastId = index + 1 || 1
      this.mapDataIndex = 0
      this.markers = []
      this.polyLines = []

      if (typeof index === 'number') {
        data = this.prepareTourMapData(this.items[index], index, true)
        this.markers = data.markers
        this.polyLines = [data.line]
      } else {
        let polyLines = []
        let markers = []
        for (let i = 0; i < this.selected.length; i++) {
          data = this.prepareTourMapData(this.selected[i], i, false) // this.items[i]
          polyLines.push(data.line)
          for (const marker of data.markers) {
            markers.push(marker)
          }
        }
        this.markers = markers
        this.polyLines = polyLines
      }
      this.$refs.modalTourMap.show()
    },
    addMarkers() {
      this.$refs.fullMap.markers = []
      this.$refs.fullMap.polyLines = []
      this.$refs.fullMap.addMarkers(this.markers)
      this.$refs.fullMap.addPolylines(this.polyLines)
    },
    generateColor() {
      return '#' + ((1 << 24) * Math.random() | 0).toString(16)
    },
    rowSelected(items) {
      this.selected = items
    },
    selectAll() {
      let toursTable = this.$refs.toursTable.$el
      let tableBody = toursTable.getElementsByTagName('tbody')[0]
      let tableRows = tableBody.getElementsByTagName('tr')
      this.unselectAll()
      for (const row of tableRows) {
        row.click()
      }
    },
    unselectAll() {
      this.$refs.toursTable.clearSelected()
    },
    myProvider (ctx) {
      console.log(ctx)
      let params = {
        page: ctx.currentPage - 1,
        limit: ctx.perPage,
        response_type: 'summary',
        sort: [
          {
            key: ctx.sortBy || 'id',
            direction: ctx.sortDesc ? 'desc' : 'asc'
          }
        ],
        includes: [
          'warehouseSlot.content'
        ]
      }
      console.log(this.filters.filter(x => x[0] !== 'id')) // stopper
      if (this.filters || this.preFilters) {
        params.filter_groups = [
          {
            filters: this.filters || this.preFilters
          }
        ]
      }
      console.log(JSON.stringify(params))

      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['country_iso_code', 'eq', window.country]
            ]
          }
        )
      }

      let promise = this.$http.get(ctx.apiUrl, { params: params })

      return promise.then((data) => {
        const items = []
        for (let i = 0; i < data.body.data.length; i++) {
          items.push(this.realVisits(data.body.data[i]))
        }
        // data.body.data.forEach(item => {
        //   items.push(this.realVisits(item))
        // })
        // // Here we could override the busy state, setting isBusy to false
        // // this.isBusy = false
        this.selectAllTrigger = false
        this.unselectAll()
        this.totalRows = data.body.pagination.total
        this.items = items
        console.log(this.items)
        return (items)
      }).catch(error => {
        console.log(error)
        // Here we could override the busy state, setting isBusy to false
        // this.isBusy = false
        // Returning an empty array, allows table to correctly handle busy state in case of error
        return []
      })
    },
    refreshTable (filters) {
      console.log(filters)
      this.filters = filters
      setTimeout(() => {
        this.$root.$emit('bv::refresh::table', 'my-table')
      }, 100)
    },
    resetData: function () {
      Object.assign(this.$data, this.$options.data.call(this))
    },
    realVisits(item) {
      let visits4Show = []
      let prevVisit
      let notOptimized
      let pickups = 0
      let dropoffs = 0
      // console.log(item)
      // item.visits.forEach(visit => {
      for (let i = 0; i < item.visits.length; i++) {
        let visit = item.visits[i]
        this.notOptimized = this.notOptimized === true || visit.order === null || false
        if (visit.type + '-' + visit.place_id !== prevVisit) {
          visit['shipping_ids'] = [visit.shipping_id]
          // visit['visited'] = 1
          visits4Show.push(visit)
          if (visit.type === 'pickup') {
            pickups++
          } else {
            dropoffs++
          }
        } else {
          // console.log(this.visits4Show[(this.visits4Show.length - 1)])
          if (visit.visited === 1) {
            visits4Show[(visits4Show.length - 1)].visited = 1
          }
          visits4Show[(visits4Show.length - 1)].shipping_ids.push(visit.shipping_id)
        }
        prevVisit = visit.type + '-' + visit.place_id
      }

      item.pickups = pickups
      item.dropoffs = dropoffs
      item.visits4Show = visits4Show
      item.notOptimized = notOptimized
      return item
    },
    downloadCsv(admin = false) {
      let filename = this.moment().format('YYYY-MM-DD_HH:mm:ss') + '__exported_tours.csv'

      let params = {
        format: 'csv',
        ids: []
      }
      if (admin) {
        params.admin_view = true
      }
      for (const row of this.selected) {
        params.ids.push(row.id)
      }

      this.$http.get(this.$appConfig.api.baseUrl + 'tours/list', { params: params })
        .then(response => {
          let blob = new Blob([response.body], { type: 'text/csv;charset=utf-8;' })
          if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename)
          } else {
            let link = document.createElement('a')
            if (link.download !== undefined) { // feature detection
              // Browsers that support HTML5 download attribute
              let url = URL.createObjectURL(blob)
              link.setAttribute('href', url)
              link.setAttribute('download', filename)
              link.style.visibility = 'hidden'
              document.body.appendChild(link)
              link.click()
              document.body.removeChild(link)
            }
          }
        })
    }
  }
}
</script>
